import { useTranslation } from 'react-i18next';

import { config } from '../../../config';
import { LoanDocumentEnum } from '../../../store/loanDocumentStore/enums/LoanDocumentEnum';
import { Component as LoanDocumentUploadPage } from '../LoanDocumentUploadPage/LoanDocumentUploadPage';

export function Component() {
  const { t } = useTranslation();

  return (
    <LoanDocumentUploadPage
      exampleDocumentUrl={config.loanDocuments.ric.exampleDocumentUrl}
      subtitleText={t('LoanDocumentUploadRICPage.subtitle')}
      titleText={t('LoanDocumentUploadRICPage.title')}
      type={LoanDocumentEnum.RIC}
    />
  );
}

Component.displayName = 'LoanDocumentUploadRICPage';
